import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { TableIds } from 'src/api/types/misc';
import Audit from 'src/components/Audit';
import ExpandSection from 'src/components/ExpandSection';

interface AuditSectionProps {
  version?: string;
}

export const AuditSection: React.FC<AuditSectionProps> = ({ version }) => {
  const { assessmentId } = useParams<{ assessmentId: string }>();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ExpandSection title="ACTIVITY" defaultOpen={false} onChange={setIsOpen} sectionId="assessment_audit">
      {isOpen && (
        <div
          style={{
            maxHeight: '800px',
            position: 'relative',
          }}
        >
          <Audit
            rootPath="assessments"
            initQuery={{ version, assessment_id: assessmentId }}
            tableId={TableIds.auditAssessment}
            noHide
            topSpacer={0}
            maxHeight={800}
            toolbar
          />
        </div>
      )}
    </ExpandSection>
  );
};
